export default __webpack_public_path__ + "static/media/profile.ae27467b.jpeg";